const safeExternalLinks = () => {
	const documentLinks = document.links;

	for ( documentLink of documentLinks ) {

		if ( documentLink.hostname !== window.location.hostname ) {
			console.log( documentLink );
			documentLink.rel = 'noopener noreferrer';
		}
	};
}
